import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

// Otis Kit PRO components
import MKBox from 'components/MKBox';

// Otis Kit PRO examples
// import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from 'examples/Cards/BlogCards/CenteredBlogCard';
import bgFront from 'assets/images/Rafa.png';
import google from 'assets/card/patner.png';
import certificacion from 'assets/card/certificacion.png';
import StatsOnee from 'layouts/sections/page-sections/stats/components/StatsOne';

import MKTypography from 'components/MKTypography';

function FeaturesTwo() {
  return (
    <MKBox component="section" id="nosotros" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={8}>
            <MKTypography
              variant="h3"
              color="#1A73E8"
              textAlign="center"
              mt={-10}
              sx={{ color: '#1A73E8' }}
            >
              NOSOTROS
            </MKTypography>

            <MKTypography variant="body2" color="text" textAlign="center" mt={2} data-aos="fade-up">
              Con base en la metodología DevOps y nuestra experiencia en procesos de I+D+i, te
              acompañamos en la identificación de necesidades tecnológicas, diseñamos la solución y
              desarrollamos la tecnología especializada de manera integral. Todo esto con el
              objetivo de generar capacidades tecnológicas al interior de tu organización para
              impulsar su transformación digital
            </MKTypography>
            <Grid data-aos="fade-up">
              <StatsOnee />
            </Grid>

            <MKBox mt={-5} display="flex" justifyContent="center" data-aos="fade-up">
              <img
                src={google}
                alt="Google Partner"
                style={{ width: '150px', height: '150px', objectFit: 'contain' }}
              />
              <img
                src={certificacion}
                alt="Certificación de calidad"
                style={{ width: '100px', height: '100px', objectFit: 'contain', marginTop: '25px' }}
              />
            </MKBox>
          </Grid>
          {/* 
          <Grid item xs={12} lg={6}>
            <Grid container justifyContent="flex-start">
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="+5 paises"
                    description="We get insulted by others, lose trust for those We get back freezes"
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="payments"
                    title="Payments functionality"
                    description="We get insulted by others, lose trust for those We get back freezes"
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="apps"
                    title="Prebuilt components"
                    description="We get insulted by others, lose trust for those We get back freezes"
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="3p"
                    title="Improved platform"
                    description="We get insulted by others, lose trust for those We get back freezes"
                  />
                </MKBox>
              </Grid>
            </Grid>
          </Grid>
          */}
          <Grid item xs={12} lg={4} sx={{ ml: 'auto', mt: { xs: 3, lg: 0 } }}>
            <CenteredBlogCard
              image={bgFront}
              imageSx={{ height: 150, objectFit: 'contain' }} // Arreglado: "heigt" → "height"
              // title="Get insights on Search"
              // description="Con base en la metodología DevOps y nuestra experiencia en procesos de I+D+i, te acompañamos en la identificación de necesidades tecnológicas, diseñamos la solución y desarrollamos la tecnología especializada de manera integral.
              // Todo esto con el objetivo de generar capacidades tecnológicas al interior de tu organización para impulsar su transformación digital"
              action={{}}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default FeaturesTwo;
